"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateAst = exports.parse = exports.newValueRangeExpr = exports.newValueExpr = exports.newUnaryExpr = exports.newOrExpr = exports.newNullExpr = exports.newMulExpr = exports.newIdentifierExpr = exports.newEqualsExpr = exports.newEmptyExpr = exports.newComparisonExpr = exports.newAndExpr = exports.newAddExpr = exports.findProperties = exports.compileToString = exports.compileToLambdas = exports.compileAst = void 0;
const property_1 = require("@promaster-sdk/property");
const PropertyCompare = __importStar(require("./property-compare"));
var property_filter_ast_1 = require("@promaster-sdk/property/lib/property-filter-ast");
Object.defineProperty(exports, "compileAst", { enumerable: true, get: function () { return property_filter_ast_1.compileAst; } });
Object.defineProperty(exports, "compileToLambdas", { enumerable: true, get: function () { return property_filter_ast_1.compileToLambdas; } });
Object.defineProperty(exports, "compileToString", { enumerable: true, get: function () { return property_filter_ast_1.compileToString; } });
Object.defineProperty(exports, "findProperties", { enumerable: true, get: function () { return property_filter_ast_1.findProperties; } });
Object.defineProperty(exports, "newAddExpr", { enumerable: true, get: function () { return property_filter_ast_1.newAddExpr; } });
Object.defineProperty(exports, "newAndExpr", { enumerable: true, get: function () { return property_filter_ast_1.newAndExpr; } });
Object.defineProperty(exports, "newComparisonExpr", { enumerable: true, get: function () { return property_filter_ast_1.newComparisonExpr; } });
Object.defineProperty(exports, "newEmptyExpr", { enumerable: true, get: function () { return property_filter_ast_1.newEmptyExpr; } });
Object.defineProperty(exports, "newEqualsExpr", { enumerable: true, get: function () { return property_filter_ast_1.newEqualsExpr; } });
Object.defineProperty(exports, "newIdentifierExpr", { enumerable: true, get: function () { return property_filter_ast_1.newIdentifierExpr; } });
Object.defineProperty(exports, "newMulExpr", { enumerable: true, get: function () { return property_filter_ast_1.newMulExpr; } });
Object.defineProperty(exports, "newNullExpr", { enumerable: true, get: function () { return property_filter_ast_1.newNullExpr; } });
Object.defineProperty(exports, "newOrExpr", { enumerable: true, get: function () { return property_filter_ast_1.newOrExpr; } });
Object.defineProperty(exports, "newUnaryExpr", { enumerable: true, get: function () { return property_filter_ast_1.newUnaryExpr; } });
Object.defineProperty(exports, "newValueExpr", { enumerable: true, get: function () { return property_filter_ast_1.newValueExpr; } });
Object.defineProperty(exports, "newValueRangeExpr", { enumerable: true, get: function () { return property_filter_ast_1.newValueRangeExpr; } });
Object.defineProperty(exports, "parse", { enumerable: true, get: function () { return property_filter_ast_1.parse; } });
const evaluateAst = (e, properties, matchMissingIdentifiers) => property_1.PropertyFilterAst.evaluateAst(e, properties, matchMissingIdentifiers, PropertyCompare.compare);
exports.evaluateAst = evaluateAst;
//# sourceMappingURL=property-filter-ast.js.map